import { FormErrorFeedback, FormGroupLabel, theme } from '@arnold/common';
import { Button, Form, FormControl, FormGroup } from 'react-bootstrap';
import { Formik, FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled/macro';
import { FC } from 'react';
import { useSetManualDeductionMutation } from '../../generated/hooks';

type SetCreditsFormValues = {
  creditsUsed: number;
};

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${theme.spacing.d};
`;

export const SetCreditsForm: FC<{ organizationId: string }> = ({ organizationId }) => {
  const { t } = useTranslation('settings');
  const [setManualDeduction] = useSetManualDeductionMutation();

  const handleSubmit = (values: SetCreditsFormValues, { setSubmitting }: FormikHelpers<SetCreditsFormValues>) => {
    setManualDeduction({
      variables: {
        organizationId,
        creditsUsed: values.creditsUsed,
      },
      refetchQueries: ['getCreditHistory', 'Organization', 'OrganizationSetting'],
      onCompleted: () => {
        setSubmitting(false);
      },
      onError: () => {
        setSubmitting(false);
      },
    });
  };

  const name = 'creditsUsed';

  return (
    <Formik
      initialValues={{
        creditsUsed: 0,
      }}
      onSubmit={handleSubmit}
      validate={(values) => {
        const errors: Partial<SetCreditsFormValues> = {};
        if (values.creditsUsed === 0) {
          errors.creditsUsed = t('creditsUsedZero');
        }
        return errors;
      }}
    >
      {({ values, errors, handleSubmit, setFieldValue, isSubmitting }) => (
        <StyledForm onSubmit={handleSubmit}>
          <FormGroup>
            <FormGroupLabel>{t('manualDeduction')}</FormGroupLabel>
            <FormControl
              type="number"
              name={name}
              value={values.creditsUsed}
              step="any"
              onChange={(e) => {
                setFieldValue(name, parseFloat(e.target.value) || 0);
              }}
              isInvalid={!!errors[name]}
            />
            {errors[name] && <FormErrorFeedback error={errors[name]} />}
          </FormGroup>
          <Button type="submit" disabled={isSubmitting || !!errors[name]}>
            {t('save')}
          </Button>
        </StyledForm>
      )}
    </Formik>
  );
};
